import React from 'react';
import ReactDOM from 'react-dom';

import { ChakraProvider } from '@chakra-ui/react'

import './index.css'
import App from './App.js';

ReactDOM.render(
    <ChakraProvider>
        <App />
    </ChakraProvider>
);